import { render, staticRenderFns } from "./ShopingCart.vue?vue&type=template&id=1cb40055&"
import script from "./ShopingCart.vue?vue&type=script&lang=js&"
export * from "./ShopingCart.vue?vue&type=script&lang=js&"
import style0 from "./ShopingCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports